import {Component, Input} from "@angular/core";

@Component({
    selector: "fui-chrome-action",
    styleUrls: ["./chrome-action.component.scss"],
    templateUrl: "./chrome-action.component.html"
})
export class FUIChromeActionComponent {
    @Input() public active: boolean;
    @Input() public disabled: boolean;
}
